import React from 'react';

import dpdkIcon from '@images/spe-low-level-programming/dpdk.svg';

export const dpdk = {
  mainSection: {
    icon: dpdkIcon,
    elements: [
      {
        type: 'text',
        items: [
          <>
            DPDK (Data Plane Development Kit) is a set of libraries for implementing user space drivers for NICs
            (Network Interface Controllers). It is an open-source project developed under the umbrella of the Linux
            Foundation.
          </>,
          <></>,
          <>
            DPDK allows you to offload TCP packet processing from the operating system kernel to processes running in
            user space. This leads to higher computing efficiency and higher packet throughput than you would have using
            only the interrupt-driven processing provided in the kernel.
          </>,
        ],
      },
    ],
  },
  howWeHelpSection: {
    elements: [
      {
        type: 'list',
        items: [
          <>Develop DPDK Poll Mode Drivers for various hardware platforms</>,
          <>Integrate DPDK drivers with a number of applications</>,
          <>
            Contribute to your DPDK framework by fixing issues and extending the interfaces according to new PMD driver
            requirements
          </>,
          <>Develop tests to demonstrate precisely how switching to DPDK will improve your solution performance</>,
        ],
      },
    ],
    relatedResources: [
      {
        type: 'Blog post',
        items: [
          {
            title: 'How can DPDK access devices from user space?',
            link: '/blog/how-can-dpdk-access-devices-from-user-space/',
          },
        ],
      },
    ],
  },
};
